// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".image__container[data-v-890b173a]{justify-content:center;overflow:hidden;background:#999;width:100%;height:100%}.image__container[data-v-890b173a],.image__img[data-v-890b173a]{display:flex;align-items:center}.image__img[data-v-890b173a]{position:relative}", ""]);
// Exports
module.exports = exports;
